import React from 'react'

interface IconProps {
  source: string
  color: string
  size: number
}

export const Icon: React.FC<IconProps> = (props) => {
  const { source, color, size } = props

  const iconStyle: React.CSSProperties = {
    width: size,
    height: size,
    backgroundColor: color,
    maskSize: `${size} ${size}`,
    WebkitMaskSize: `${size} ${size}`,
    maskImage:`url(${source})`,
    WebkitMaskImage: `url(${source})`,
    maskRepeat: 'no-repeat',
    WebkitMaskRepeat: 'no-repeat',
    maskPosition: 'center',
    WebkitMaskPosition: 'center'
  }

  return (
    <div style={iconStyle} />
  )
}